import { useNavigate } from "react-router-dom";
import { PLAN_TYPE_META } from "../../../common/constants";

const PlanTable = ({ plans, onToggleStatus, onEdit, onDelete }) => {
  const navigate = useNavigate();

  return (
    <table className="plans-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Price</th>
          <th>Plan Type</th>
          <th>Total Sessions</th>
          <th>Status</th>
          <th>Toggle</th>
          <th>Google Plans</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        {plans.map((plan) => (
          <tr key={plan.id}>
            <td>{plan.name}</td>
            <td>₹{plan.price}</td>
            <td>
              {plan.planType === "COMBO" ? (
                <div>
                  <strong>Combo</strong>
                  <div style={{ fontSize: "0.9rem" }}>
                    {plan.sessionsGroup > 0 && <div>Group: {plan.sessionsGroup}</div>}
                    {plan.sessionsGroupDiscussion > 0 && <div>Group Discussion: {plan.sessionsGroupDiscussion}</div>}
                    {plan.sessionsOneOnOne > 0 && <div>One-on-One: {plan.sessionsOneOnOne}</div>}
                    {plan.sessionsPartnerPractice > 0 && <div>Partner Practice: {plan.sessionsPartnerPractice}</div>}
                  </div>
                </div>
              ) : (
                PLAN_TYPE_META[plan.planType]?.displayName ?? plan.planType
              )}
            </td>

            <td>{plan.totalSessions}</td>

            <td>
              <span className={`status ${plan.isActive ? "active" : "inactive"}`}>
                {plan.isActive ? "Active" : "Inactive"}
              </span>
            </td>

            <td>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={plan.isActive}
                  onChange={() => onToggleStatus(plan)}
                />
                <span className="slider" />
              </label>
            </td>

            <td>
              <button
                className="google-plan-btn"
                onClick={() => navigate(`/admin/google-plans/${plan.id}`, { state: { planName: plan.name } })}
              >
                Google Plans
              </button>
            </td>

            <td style={{ display: "flex", gap: "0.5rem" }}>
              <button className="edit-plan-btn" onClick={() => onEdit(plan)}>
                Edit
              </button>
              <button className="delete-plan-btn" onClick={() => onDelete(plan)}>
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PlanTable;
